import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';

const paddedButton: React.CSSProperties = {
  marginRight: TabStyles.Spacing.SmallSpace,
  marginLeft: TabStyles.Spacing.SmallSpace,
};

export interface ValuesSectionEditButtonsProps {
  readonly isReadonly: boolean;
  readonly isEditing: boolean;
  readonly setIsEditing: (value: boolean) => void;
}

export const ValuesSectionEditButtons = (props: ValuesSectionEditButtonsProps) => {
  // If editing is not allowed
  if(!FeatureFlags.dataRolesEditValueSynonymsEnabled || props.isReadonly) { return null; }

  // If we can edit, but currently are not editing
  if(!props.isEditing) {
    return (
      <ButtonWidget
        style={paddedButton}
        buttonType={ButtonType.Outline}
        testId="edit-values-synonyms-begin"
        handleClick={() => props.setIsEditing(true)} >
          {Messages.edit()}
      </ButtonWidget>);
  }

  // If we are currently editing and want the ability to cancel/save
  return (
    <>
      <ButtonWidget
        style={paddedButton}
        buttonType={ButtonType.Outline}
        testId={`edit-values-synonyms-cancel`}
        handleClick={() => props.setIsEditing(false)} >
          {Messages.cancel()}
      </ButtonWidget>
      <ButtonWidget
        style={paddedButton}
        buttonType={ButtonType.Go}
        testId={`edit-values-synonyms-save`}
        handleClick={() => props.setIsEditing(false)} >
          {Messages.save()}
      </ButtonWidget>
    </>);
};
